import { render, staticRenderFns } from "./PreviewDialog.vue?vue&type=template&id=0fb6a8d0&scoped=true&"
import script from "./PreviewDialog.vue?vue&type=script&lang=js&"
export * from "./PreviewDialog.vue?vue&type=script&lang=js&"
import style0 from "./PreviewDialog.vue?vue&type=style&index=0&id=0fb6a8d0&prod&lang=scss&"
import style1 from "./PreviewDialog.vue?vue&type=style&index=1&id=0fb6a8d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb6a8d0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDialog,VIcon,VRow})
